"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseType = void 0;
/**
 *The possible XHR response types for the TransportClient
 */
var ResponseType;
(function (ResponseType) {
    ResponseType["blob"] = "blob";
    ResponseType["arraybuffer"] = "arraybuffer";
    ResponseType["document"] = "document";
    ResponseType["json"] = "json";
    ResponseType["text"] = "text";
})(ResponseType = exports.ResponseType || (exports.ResponseType = {}));
